import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <h1
        className="pointer-events-none absolute inset-x-0 top-6 select-none font-heading text-[11rem] font-black leading-none text-background-300 md:text-[16rem]"
        aria-hidden="true"
      >
        404
      </h1>

      <div className="relative z-10 flex flex-col items-center">
        <p className="font-heading text-lg font-semibold text-foreground-900 md:text-xl">
          {t("notFound.title")}
        </p>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
          {t("notFound.subtitle")}
        </p>
        <p className="mt-1 text-xs text-foreground-400">{location.pathname}</p>

        <Link
          to="/"
          className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base" />
          {t("notFound.backHome")}
        </Link>
      </div>
    </div>
  );
}